<template>
	<v-dialog v-model="visible" :max-width="maxWidth" persistent>
		<v-card color="#FFFFFF">
			<v-system-bar :color="color" height="12"></v-system-bar>
			<v-alert v-if="error_msg.length !== 0" class="my-1 rounded-b-0" type="error" dense>
				{{ error_msg }}
			</v-alert>
			<div class="pa-4">
				<v-row class="ma-0">
					<span class="title-sytle">information</span>
				</v-row>
				<ProgressLinear v-if="loading" class="mx-0 mt-2 mb-4"/>
				<v-row v-if="!loading" class="mx-0 mt-2 mb-4" justify="center">
					<v-col cols="12" class="px-0">
						<div class="item-style">Phase</div>
						<v-select
							v-model="phase_local"
							:color="color"
							:menu-props="{ bottom: true, offsetY: true}"
							:loading="phase_loading"
							:items="phase_items"
							:disabled="infoId !== 0"
							item-value="id"
							item-text="desc"
							item-color="media"
							background-color="#FAFAFA"
							outlined
							dense
							hide-details
							return-object
						>
						</v-select>
					</v-col>
				</v-row>
				<v-row v-if="!loading" class="mx-0 mt-2 mb-4" justify="center">
					<RichText v-model="content" :toolbar="toolbar" :plugins="plugins" :height="250" :width="$vuetify.breakpoint.xsOnly ? $vuetify.breakpoint.width - (16 * 5) :maxWidth - (16 * 2) " />
				</v-row>
				<v-row class="ma-0" justify="center">
					<v-btn outlined class="text-capitalize mr-2" color="rgba(25, 42, 62, 0.7)" max-height="36" @click="$emit('close')">Cancel</v-btn>
					<v-btn class="text-capitalize white--text" :color="color" elevation="0" :disabled="!buttonActive" @click="onSave()">
						<span v-if="infoId !== 0">Save changes</span>
						<span v-else>Add Infomation</span>
					</v-btn>
				</v-row>
			</div>
		</v-card>
	</v-dialog>
</template>
<script>
import ProgressLinear from "@/components/progress/progress_getdata_linear.vue";
import RichText from '@/views/rtf/RichText';

/**
 * https://github.com/antoniolucasnobar/html-to-rtf-browser
 * copy whole src into project(removing testing file)
 **/
import Rtf from "@/views/rtf/html_to_rtf/rtf/rtf.class.js";
const htmlToRtf = new Rtf();

const Plugins = 'advlist lists image link';
const Toolbar = ['bold italic underline strikethrough backcolor forecolor | indent outdent| align numlist bullist | link image'];

export default {
	name: 'MediaPlanInfoDialog',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		maxWidth: {
			type: Number,
			default: 600
		},
		color: {
			type: String,
			default: '#605AF6'
		},
		jobId: {
			type: Number,
			default: 0
		},
		snapId: {
			type: Number,
			default: 0
		},
		infoId: {
			type: Number,
			default: 0
		},
		phase: {
			type: Object,
			default: null
		},
		detail: {
			type: Object,
			default: null
		}
	},
	components: {
		ProgressLinear,
		RichText
	},
	data() {
		this.plugins = Plugins;
		this.toolbar = Toolbar;

		return {
			error_msg: '',
			loading: true,

			phase_loading: false,
			phase_local: this.phase,
			phase_items: [],

			content: '',
			order: 0,
			do_print: true
		}
	},
	created() {
		setTimeout(() => { this.loading = false }, 1000);

		this.getPhaseList();

		if (this.infoId !== 0) {
			this.getMediaInfo(this.infoId);
		}
	},
	computed: {
		buttonActive() {
			let active = false;

			if (this.content.length !== 0 && !this.loading) {
				active = true;
			}

			return active;
		}
	},
	methods: {
		getPhaseList() {
			this.phase_loading = true;

			const url = `/api/jobs/${this.jobId}/phases`;

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, data, reason } = val.data;
					if (status == "OK") {
						this.phase_items = data.map((d, index) => { 
							const obj = {
								id: d.id,
								desc: d.display_name,
								order: index
							};

							return obj;
						});

						if (this.infoId === 0) {
							this.phase_local = this.phase_items[0];
						}
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.phase_loading = false;
				});
		},
		getMediaInfo(info_id) {
			this.loading = true;

			const url = `/api/media/media_planning/info/${info_id}`;

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, data, reason } = val.data;
					if (status == "OK") {
						this.phase_local = data.phase;
						this.content = data.info_text;
						this.order = data.order;
						this.do_print = data.do_print;			
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		onSave() {
			const params_obj = {
				phase_id: this.phase_local.id,
				info_text: this._htmlToPlain(this.content),
				order: this.order,
				do_print: this.do_print,
			};

			params_obj['info_rtf'] = this.content.length !== 0 ? htmlToRtf.convertHtmlToRtf(this.content): '';

			if (this.snapId !== 0) {
				params_obj['snap_id'] = this.snapId
			}

			if (this.infoId === 0) {
				this._onCreateInfo(params_obj);
			} else {
				this._onUpdateInfo(params_obj)
			}
		},
		_onCreateInfo(params_obj) {
			const url = '/api/media/media_planning/info';

			axios
				.post(url, params_obj, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const json = val.data;

					const { status, reason } = json;

					if (status == "OK") {
						this.$emit('close', true)
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		_onUpdateInfo(params_obj) {
			const url = `/api/media/media_planning/info/${this.infoId}`;

			axios
				.put(url, params_obj, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason } = val.data;

					if (status == "OK") {
						this.$emit('close', true)
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
		},
		_htmlToPlain(html_str) {
			const dom_tmp = document.createElement('div');
			dom_tmp.innerHTML = html_str;
			return dom_tmp.textContent || dom_tmp.innerText || '';
		}
	}
}
</script>
<style lang="scss" scoped>
.title-sytle {
  font-family: Roboto;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #605AF6;
}
.item-style {
  font-family: Roboto;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #37495F;
}
</style>